import React from 'react';
import { Box, Checkbox, Button } from '@material-ui/core';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-regular-svg-icons";

export const ColTodosPedidos = (
  handlerOpcoesRecebimentoTodosPedidos,
  handleToggleCheckboxEtiquetasTodosPedidos,
  handleDataTodosPedidosSelectedEtiquetas,
  props,
) => {
  return [
    {
      name: "",
      options: {
        display: true,
        filter: false,
        download: false,
        viewColumns: false,
        customBodyRender: (tableMeta, updateValue) => {
          const checked = handleToggleCheckboxEtiquetasTodosPedidos(updateValue.rowData);
          return (
            <Box align="center">
              <Checkbox
                edge="start"
                disableRipple
                checked={checked}
                onChange={() => handleDataTodosPedidosSelectedEtiquetas(updateValue.rowData)}
              />
            </Box>
          );
        },
      },
    },
    {
      group: 4,
      name: 'purchaseOrderId',
      label: 'Número Pedido',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 4,
      name: 'paymentId',
      label: 'Cond Pagamento',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 4,
      name: 'productId',
      label: 'Id Prod',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 4,
      name: 'numericCode',
      label: 'Cod Numérico',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 4,
      name: 'productName',
      label: 'Descrição',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 4,
      name: 'colorAbbreviation',
      label: 'Cor',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 1,
      name: 'issueDate',
      label: 'Data de Emissão',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 1,
      name: 'deliveryDate',
      label: 'Data Original',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 1,
      name: 'expectedDeliveryDate',
      label: 'Data Prevista',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 1,
      name: 'scheduleDate',
      label: 'Data de agendamento',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 3,
      name: 'itemQuantity',
      label: 'Quantidade de itens',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 2,
      name: 'quantityDelivery',
      label: 'Qtd Entregue',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      name: '-',
      label: 'Histórico de agendamento',
      options: {
        display: true,
        viewColumns: false,
      },
    },
    {
      group: 2,
      name: 'quantityOutstanding',
      label: 'Qtd Pendente',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 5,
      name: 'personId',
      label: 'ID Fornecedor',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 5,
      name: 'personName',
      label: 'Fornecedor',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 3,
      name: 'unitaryValue',
      label: 'Custo Unitário',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 3,
      name: 'percentValueIPI',
      label: '% IPI',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 1,
      name: 'forecastQuantity',
      label: 'Atraso Previsto',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 3,
      name: 'amount',
      label: 'Valor Total',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 3,
      name: 'outstandingAmount',
      label: 'Valor Pendente',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 2,
      name: 'amountOutstandingVolume',
      label: 'Qtd de volumes pendentes',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 2,
      name: 'scheduleQuantity',
      label: 'Qtd Agendada',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 2,
      name: 'quantityVolumeSchedule',
      label: 'Qtd de volumes agendados',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 4,
      name: 'GEPDescription',
      label: 'Grupo',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 4,
      name: 'familyId',
      label: 'Família',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 4,
      name: 'orderTypeDescription',
      label: 'Tipo do pedido',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 4,
      name: 'branchDeliveryId',
      label: 'Dep Entrega',
      options: {
        display: false,
        viewColumns: true,
      },
    },
    {
      group: 4,
      name: 'alphaId',
      label: 'Código Alfa',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 4,
      name: 'sciaStatusDescription',
      label: 'Status',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 3,
      name: 'qualityIndex1',
      label: '%IQ1',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 3,
      name: 'MercosurCommonName',
      label: 'NCM',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 3,
      name: 'monetaryPenaltySchedule',
      label: 'Valor Penalidade (R$)',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 3,
      name: 'percentDiscont',
      label: '% Desconto',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 3,
      name: 'monetaryDiscont',
      label: 'Valor Desconto (R$)',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 3,
      name: 'netDiscount',
      label: 'Valor líquido (Valor R$ total com o desconto aplicado)',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    {
      group: 3,
      name: 'advanceRequest',
      label: 'Solicitado antecipação (sim/não)',
      options: {
        display: true,
        viewColumns: true,
      },
    },
    // {
    //     group: 6,
    //     name: 'OPCOES_RECEBIMENTO',
    //     label: 'Alterar opção de pagamento',
    //     options: {
    //         display: user.permissions["gerenciar-pedidos.todos-pedidos.features-adicionais"],
    //         viewColumns: true,
    //         customBodyRender: (value, tableMeta, updateValue) => {
    //             return(
    //                 ButtonOpcoes(
    //                     value, tableMeta, updateValue, handlerOpcoesRecebimentoTodosPedidos
    //                 )
    //             );
    //         }
    //     },
    // },
  ];
};